/*
 * Пин-код быстрого входа привязан к устройству: браузер помнит логин, для
 * которого пин настроен, человек вводит только 4 цифры. Сам пин здесь не
 * хранится — только логин; проверка всегда на сервере.
 *
 * Рядом с логином запоминается имя: на экране входа человека приветствуют
 * по имени и фамилии, а не по никнейму — никнейм в интерфейсе не показываем.
 *
 * В приложении для iPhone пин-входа нет: его роль берёт Face ID.
 */

import { isApp } from '../native/env';

const KEY = 'code-pin-login';
const NAME = 'code-pin-name';
const SKIP = 'code-pin-skip';

/** Логин, для которого на этом устройстве настроен пин, либо null. */
export const pinLoginOf = (): string | null => (isApp() ? null : localStorage.getItem(KEY));

/** Имя и фамилия человека с пином на этом устройстве, либо null. */
export const pinNameOf = (): string | null => localStorage.getItem(NAME);

export const rememberPinLogin = (login: string, name?: string) => {
  localStorage.setItem(KEY, login);
  if (name && name.trim()) localStorage.setItem(NAME, name.trim());
  else localStorage.removeItem(NAME);
};

export const forgetPinLogin = () => {
  localStorage.removeItem(KEY);
  localStorage.removeItem(NAME);
};

/** «Не предлагать пин на этом устройстве» — до следующей установки. */
export const pinOfferSkipped = (login: string): boolean => isApp() || localStorage.getItem(SKIP) === login;

export const skipPinOffer = (login: string) => localStorage.setItem(SKIP, login);

export const clearPinSkip = () => localStorage.removeItem(SKIP);
